import { Pipe, PipeTransform } from '@angular/core';

import { SingleDatePickerItem } from '../interfaces/single-date-picker-item.interface';

import { isValidDateForDateRange } from '../utils/single-date-picker-utils';

/**
 * Is Valid Date For Date Range Pipe
 *
 * Checks if a date should be selectable based on the following:
 *  1. The role of a SingleDatePicker within a DateRangeComponent (whether the datepicker is the start or end of the range)
 *  2. What date(s) are already selected for the range.
 */
@Pipe({
    name: 'isValidDateForDateRange',
    standalone: false,
})
export class isValidDateForDateRangePipe implements PipeTransform {
    transform(
        dateItemOrDate: SingleDatePickerItem | Date,
        selectedStartDate: Date | null,
        selectedEndDate: Date | null,
        isStartOfRange: boolean,
        startDate?: Date,
        endDate?: Date
    ): boolean {
        return isValidDateForDateRange(
            dateItemOrDate,
            selectedStartDate,
            selectedEndDate,
            isStartOfRange,
            startDate,
            endDate
        );
    }
}
